module.exports = __webpack_public_path__ + "6b707c61/img/document.e2130c6b.svg";